import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Box from '@mui/material/Box';

import { BaseLayout } from '../App';
import RequirePermission from '../components/AuthGuards/RequirePermission';
import Footer from '../components/Footer';
import CheckoutHeader from '../pages/Checkout/components/common/Header';

const Payment = lazy(() => import('../pages/Checkout/components/payment'));
const ThankYou = lazy(() => import('../pages/Checkout/components/thankyou'));

// The payment and thank-you pages. Light since the 2026-10 redesign, like the
// rest of the site: the page's own ivory, with the checkout header above and
// the legal links below.
//
// THE LEGAL LINKS. The site footer does not render here, and until the
// redesign this layout linked the Refund and Cancellation Policy alone (email
// item 6, "linked at checkout"). It now carries the same links as the site
// footer and keeps the refund policy with them (email item 1, "footer-linked
// throughout"). Each opens in a new tab so the buyer does not lose checkout
// progress. See Footer's `checkout` prop.
export const CheckoutLayout = () => {
  return (
    <BaseLayout>
      <CheckoutHeader />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '86vh',
        }}
      >
        <Box
          component="main"
          sx={{
            flex: 1,
          }}
        >
          <Outlet />
        </Box>
        <Footer checkout />
      </Box>
    </BaseLayout>
  );
};

const CheckoutRoutes = {
  path: 'checkout',
  element: <CheckoutLayout />,
  children: [
    // licence.purchase on both steps: only the roles that may buy
    // (cw-platform-admin, buyer-admin, buyer-user) can reach payment or the
    // receipt. Guards sit on the children rather than the layout so the
    // layout's Provider is already mounted when the guard reads the store.
    {
      path: 'payment',
      element: (
        <RequirePermission permission="licence.purchase">
          <Suspense fallback={<div />}>
            <Payment />
          </Suspense>
        </RequirePermission>
      ),
    },
    {
      path: 'thanks',
      element: (
        <RequirePermission permission="licence.purchase">
          <Suspense fallback={<div />}>
            <ThankYou />
          </Suspense>
        </RequirePermission>
      ),
    },
  ],
};

export default CheckoutRoutes;
